import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@material-ui/core"
import {ExpandMore as ExpandMoreIcon, MonetizationOn as TransactionIcon} from "@material-ui/icons"

import {CustomerPaymentPlanSetupSucceeded} from "@indebted/api"

function PaymentPlanSetupSucceededActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerPaymentPlanSetupSucceeded},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<TransactionIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>ID:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.PaymentPlanID}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Amount:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Amount}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Start Date:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.StartDate}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>End Date:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.EndDate}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Instalment Amount:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.InstalmentAmount}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Number Of Instalments:</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.NumberOfInstalments}
							</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Frequency:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Frequency}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {PaymentPlanSetupSucceededActivity}
